import { useState } from "react"
import { useScope } from "../SelectProjectCompanyContainer"
import { useSelector } from "react-redux"
import { useUsers, useUsersProject } from "../../core/utils/hooks/useUsers"
import { exportUsersProject, exportUsersTraining, exportUsersSupplier, exportSelectedForms } from "../../core/utils/exports"
import ReportsScreen from "../../screen/ReportsScreen"
import { VALE_USERS_EMAIL } from "../../core/vale/users"

function ReportsContainer() {
  const user = useSelector((state) => state.app?.user?.user)
  const [desc, setDesc] = useState()
  const { users } = useUsers()
  const {usersProject} = useUsersProject()
  const { scope } = useScope()
  
  const {exportUsers} = exportUsersProject(users, 'users_engagement_')
  const usersTraining = exportUsersTraining(usersProject, desc)
  const usersSupplier = exportUsersSupplier(scope)
  const {exportForms, loading } = exportSelectedForms()

  const [modalIsOpen, setModalIsOpen] = useState(false)

  const linkDesc = (e) => {
    setDesc(e.target.value)
  }

  return (
    <ReportsScreen
      {...{
        usersTraining,
        usersSupplier,
        usersByProject: exportUsers,
        exportForms,
        loading,
        modalIsOpen,
        setModalIsOpen,
        hideDownloadOptions: VALE_USERS_EMAIL.includes(user?.email)
      }}
      value={desc}
      onChange={linkDesc}
    />
  )
}

export default ReportsContainer
